import {DomSanitizer} from '@angular/platform-browser';
import {Pipe} from '@angular/core';

@Pipe({
    name: "safeHtml",
    standalone: true
})
export class SafeHtmlPipe {
  constructor(private sanitizer: DomSanitizer) {}

  transform(html) {
    return this.sanitizer.bypassSecurityTrustHtml(
      this.removeCloseButtonfromHtml(html)
    );
  }

  removeCloseButtonfromHtml(html: string) {
    // Create a temporary div element to hold the HTML string
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Find the <button.closeElement> element inside the tempDiv
    const buttonElement = tempDiv.querySelectorAll("button.closeButton");

    // Remove the <button.closeButton> element if it exists
    if (buttonElement) {
      buttonElement.forEach((element) => {
        element.parentNode.removeChild(element);
      });
    }

    // Get the updated HTML string from the tempDiv
    return tempDiv.innerHTML.toString();
  }
}
